export const environment = {
    api_url: "https://api.zulucourier.com",
    app_url: "https://zulucourier.com",
    google_maps_key: "AIzaSyD08c2xB9f0f8MgYO8JgMLZF-VyT0VB-RI",
    CRISP_APP_KEY: "6508cb8b-8aa3-4625-b9d4-7ad122e5dece",
    STRIPE_PUBLIC_KEY:"pk_live_51NLfZ8HWXHWWhWggwODDs4vD2Uq1Zc5U3Qbg29Kgxj8h6Jz0kbKYlGRHnrWWGRFFXttpiizADv9QskB0eQONTUJY00APbgBRBC",
    
    CORRECT_PASSCODE:"admin123",

    apiKey: "AIzaSyBMYeCdg479wtmZv7XljUVFqjUDfdnI55s",
    authDomain: "maximal-arcadia-390604.firebaseapp.com",
    databaseURL: "https://live-390604.firebaseio.com",
    projectId: "maximal-arcadia-390604",
    storageBucket: "maximal-arcadia-390604.firebasestorage.app",
    messagingSenderId: "262126210373",
    appId: "1:262126210373:web:6508dd63a293767576422c",

    // Mobile App Download Prompt Configuration
    SHOW_MOBILE_APP_PROMPT: false, // Set to false to disable mobile app download prompt
    MOBILE_PROMPT_STYLE: "modal", // Options: "modal", "banner", "none"
    MOBILE_PROMPT_DELAY: 2000, // Delay in milliseconds before showing prompt
    // Note: "Continue in Browser" dismisses for 24 hours, "Close" shows again on refresh
    ANDROID_APP_URL: "https://play.google.com/store/apps/details?id=com.zulucourier.app",
    IOS_APP_URL: "https://apps.apple.com/app/zulu-courier/id123456789",
};
